module.exports = __webpack_public_path__ + "img/bb9.457bb6a5.jpg";